import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Spin } from 'antd';
// componets
// actions
import groupsAction from '../../../../redux/actions/groups';
// types
import { stateType } from '../../../../types/types';
// styles
import './style.scss';
// icons
import { ReactComponent as CloseIcon } from 'assets/image/account/close4.svg';
import FormAddEvent from '../../forms/adds/events';

const AddEvent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(groupsAction.getTopics());
    dispatch(groupsAction.getTherapists());
  }, []);

  const loader = useSelector((state: stateType) => state.events.loaderModal);

  const open = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <button className="btn-form" style={{ width: '263px' }} onClick={open}>
        + Add Another Event
      </button>
      {visible && (
        <Modal
          visible={visible}
          onOk={handleOk}
          closable={true}
          onCancel={handleCancel}
          centered
          maskTransitionName="none"
          footer={null}
          className="add-event-modal"
          closeIcon={<CloseIcon />}
        >
          <Spin spinning={loader}>
            <ModalContainer setVisible={setVisible} />
          </Spin>
        </Modal>
      )}
    </>
  );
};

export default AddEvent;

const ModalContainer = ({ setVisible }: any) => {
  return (
    <div className="add-event-container">
      <div className="add-event-container__title">Add Event</div>
      <FormAddEvent setVisible={setVisible} />
    </div>
  );
};
